import React from 'react';
import Customers from '../Users/Customers';

const Users = () => <Customers />;

export default Users;
